<template>
  <div class="row product-search">
    <div class="col-lg-8 my-2 d-flex position-relative align-items-baseline">
      <div class="mx-2 form-search" ref="SearchInput">
        <input
          type="text"
          class="mb-4 search-input"
          v-model="searchQuery"
          :placeholder="$t('search_product_component.placeholder.search')"
          @focus="ShowProducts"
        />
        <i class="ti ti-search"></i>

        <div class="results" v-if="showResults" ref="resultsContainer">
          <div class="results-inner">
            <div
              v-if="products.length === 0 && !productsStore.loadingFilter && !productsStore.error"
              class="no-products"
            >
              Aucun résultat pour cette recherche
            </div>
            <div
              class="result-item"
              v-for="product in products"
              :key="product.id"
              :class="{ 'delegate-product': product.isDelegateProduct }"
            >
              <div class="product-card">
                <div class="left-product-card">
                  <div class="product-image">
                    <img :src="product.imagesDetails[0]?.path || ProductDefault" class="img-product" />
                  </div>
                  <div class="product-info mx-2 mt-3">
                    <span class="gamme">{{ product.gamme_supplyvet || "" }}</span>
                   
                    <h3 class="title">{{ product.inventoryName }}</h3>
                    <span
                      v-if="product.datePrecommandeSupplyvetEsupplyvet && new Date(product.datePrecommandeSupplyvetEsupplyvet) > new Date()"
                      class="preorder-badge"
                    >
                      Précommande : livraison à partir du
                      {{ new Date(product.datePrecommandeSupplyvetEsupplyvet).toLocaleDateString('fr-FR') }}
                    </span>
                    <p>{{ product.name || "" }}</p>
                    <!-- <span v-if="product.ref">
                      {{ $t('search_product_component.labels.ref') }} {{ product.ref }}
                    </span> -->
                    <span v-if="product.isDelegateProduct" class="delegate-badge">Délégué</span>

                    <div v-if="isDelegue && !product.isDelegateProduct" class="free-unit-section">
                      <label class="free-unit-label">Unité gratuite</label>
                      <div class="free-unit-checkboxes">
                        <!-- <label class="checkbox-item">
                          <input 
                            type="checkbox" 
                            :checked="selectedFreeUnits[product.id] === 1"
                            @change="updateFreeUnitSelection(product.id, 1)"
                          />
                          <span>20%</span>
                        </label>
                        <label class="checkbox-item">
                          <input 
                            type="checkbox" 
                            :checked="selectedFreeUnits[product.id] === 2"
                            @change="updateFreeUnitSelection(product.id, 2)"
                          />
                          <span>50%</span>
                        </label>
                        <label class="checkbox-item">
                          <input 
                            type="checkbox" 
                            :checked="selectedFreeUnits[product.id] === 3"
                            @change="updateFreeUnitSelection(product.id, 3)"
                          />
                          <span>100%</span>
                        </label> -->
                        <label class="checkbox-item">
                          <input
                            type="checkbox"
                            :checked="selectedFreeUnits[product.id] === 4"
                            @change="updateFreeUnitSelection(product.id, 4)"
                          />
                          <span>unité</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="right-product-card">
                  <div class="actions-cart">
                    <div class="input-wrapper">
                      <div class="number-input-block">
                        <div class="btn-minus" @click.prevent.stop="Decrement(product)">-</div>
                        <input
                          type="text"
                          class="number-input"
                          v-model="qt[product.id]"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          @input="onQtyInput(product, $event)"
                          @blur="onQtyBlur(product)"
                          @keydown="onQtyKeydown"
                        />
                        <div class="btn-plus" @click.prevent.stop="Increment(product)">+</div>
                      </div>
                      <span v-if="product.currentChannelPricings" class="price my-auto px-0 mx-0">
                        <!-- Display "Offert" for delegate products with price 0 -->
                        <span v-if="product.isDelegateProduct && product.currentChannelPricings.price === 0">
                          Offert
                        </span>
                        <span v-else>
                          {{ formatPrice(!isClient ? product.price_ht : product.price_ttc) }}
                          <span class="currency" v-if="!isClient">{{
                            $t("search_product_component.units.price_ht")
                          }}</span>
                          <span class="currency" v-else>{{ $t("search_product_component.units.price_ttc") }}</span>
                        </span>
                      </span>
                    </div>
                    <div
                      v-if="cartStore.loadingId !== product.id"
                      class="add-cart"
                      @click.prevent.stop="AddToCart(product)"
                    >
                      <span class="add-cart-plus">
                        <ii class="ti ti-plus" />
                      </span>
                    </div>
                    <span v-else class="dot-spinner-container">
                      <span class="dot-spinner">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="load-more" v-if="hasMoreProducts && showResults">
              <button class="btn btn-orange m-4" :disabled="productsStore.loadingFilter" @click.prevent="loadMore">
                {{
                  productsStore.loadingFilter
                    ? $t("search_product_component.labels.loading")
                    : $t("search_product_component.labels.show_more")
                }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="productsStore.error" class="error-message">
          {{ productsStore.error }}
        </div>
      </div>
      <div class="message-added" v-if="qt_cart > 0 && ShowSuccessMsg">
        <label class="success-add-product py-1 my-2">{{
          $t("search_product_component.labels.product_added_success")
        }}</label>
      </div>
      <div class="d-cart" :class="{ 'cart-visible': qt_cart > 0 }" v-if="$route.path === '/dashboard'">
        <div class="d-flex align-items-center">
          <div class="cart-wrapper">
            <div class="cart-container">
              <img :src="iconcart" />
              <span class="badge">{{ qt_cart }}</span>
            </div>
          </div>
          <div class="go_payment">
            <label v-if="qt_cart > 0" class="check-payment" @click.prevent="GoToCart">{{
              $t("search_product_component.labels.go_to_checkout")
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, computed, watch } from "vue";
  import { debounce } from "lodash";
  import iconsearch from "../assets/search.svg";
  import iconplus from "../assets/plus.svg";
  import iconcart from "../assets/cart_white.png";
  import ProductDefault from "@/assets/images/product_default.png";
  import { useCartStore } from "@/stores/cartStore";
  import { useProductsStore } from "@/stores/productsStore";
  import { useToast } from "vue-toastification";
  import $ from "jquery";
  import { useRegisterStore } from "@/stores/register";

  export default {
    name: "SearchProduct",
    setup() {
      const searchQuery = ref("");
      const showResults = ref(false);
      const ShowSuccessMsg = ref(false);
      const qt = ref({});
      const SearchInput = ref(null);
      const productsStore = useProductsStore();
      const cartStore = useCartStore();
      const toast = useToast();
      const registerStore = useRegisterStore();

      // New reactive state for free unit selections
      const selectedFreeUnits = ref({});

      const debouncedFetchProducts = debounce(query => {
        productsStore.fetchAllProducts({ page: 1, itemsPerPage: 8 }, query);
      }, 300);

      watch(searchQuery, newQuery => {
        if (newQuery && newQuery.trim().length > 0) {
          showResults.value = true;
          // Ensure styling matches open state
          $(".search-input").css({
            "border-radius": "25px 25px 0 0",
            "border-bottom": "none",
          });
        }
        debouncedFetchProducts(newQuery);
      });

      const isClient = computed(() => {
        return registerStore.user?.role === "client";
      });

      const isDelegue = computed(() => {
        return registerStore.user?.role === "delegues";
      });

      const qt_cart = computed(() => cartStore.CountCart);

      const products = computed(() => {
        const products_variants = [];

        productsStore.products.forEach(prod => {
          if (prod.variantsDetails) {
            prod.variantsDetails.forEach(variant => {
              // Check if product has "delegue" tag
              const isDelegateProduct = prod.tagProduit && prod.tagProduit.includes("delegue");

              // For delegates: allow products with price >= 0, especially delegate-tagged products
              // For non-delegues: only show products with price > 0
              const priceCondition = isDelegue.value
                ? variant.currentChannelPricings && (variant.currentChannelPricings.price >= 0 || isDelegateProduct)
                : variant.currentChannelPricings && variant.enabled !== false;

              const isPrecommande = 
                (variant.datePrecommandeSupplyvetEsupplyvet && new Date(variant.datePrecommandeSupplyvetEsupplyvet) > new Date()) ||
                (prod.datePrecommandeSupplyvetEsupplyvet && new Date(prod.datePrecommandeSupplyvetEsupplyvet) > new Date());

              if ((variant.inStock || isPrecommande) && priceCondition) {
                if (variant.imagesDetails.length === 0) {
                  const matchingVariant = prod.variantsDetails.find(v => {
                    const isNonPack = !v.unity || v.unity === "u" || !/^\d+u$/.test(v.unity);
                    return (
                      v.contenance === variant.contenance && isNonPack && v.imagesDetails && v.imagesDetails.length > 0
                    );
                  });

                  if (matchingVariant) {
                    variant.imagesDetails = matchingVariant.imagesDetails;
                  } else {
                    variant.imagesDetails = prod.imagesDetails || [];
                  }
                }

                products_variants.push({
                  ...variant,
                  gamme: prod.gamme,
                  gamme_supplyvet: prod.gamme_supplyvet,
                  isDelegateProduct,
                  datePrecommandeSupplyvetEsupplyvet: variant.datePrecommandeSupplyvetEsupplyvet || prod.datePrecommandeSupplyvetEsupplyvet,
                });

                if (!qt.value[variant.id]) {
                  qt.value[variant.id] = 1;
                }
              }
            });
          }
        });

        return products_variants;
      });

      const hasMoreProducts = computed(() => productsStore.products.length < productsStore.totalProducts);

      // Method to update free unit selection
      const updateFreeUnitSelection = (productId, percentage) => {
        if (selectedFreeUnits.value[productId] === percentage) {
          // If clicking the same checkbox, deselect it
          selectedFreeUnits.value[productId] = null;
        } else {
          // Select the new percentage
          selectedFreeUnits.value[productId] = percentage;
        }
      };

      return {
        iconsearch,
        iconplus,
        iconcart,
        ProductDefault,
        searchQuery,
        showResults,
        ShowSuccessMsg,
        qt,
        SearchInput,
        productsStore,
        cartStore,
        qt_cart,
        products,
        hasMoreProducts,
        debouncedFetchProducts,
        toast,
        isClient,
        isDelegue,
        selectedFreeUnits,
        updateFreeUnitSelection,
      };
    },
    props: {
      ListProducts: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    mounted() {
      document.addEventListener("click", this.hideWithDelay);
      if (this.qt_cart > 0) {
        $(".d-cart").css({ top: "0%", right: "-24%" });
      }
    },
    beforeUnmount() {
      document.removeEventListener("click", this.hideWithDelay);
    },
    methods: {
      ShowProducts() {
        if (this.productsStore.products.length === 0) {
          this.productsStore.fetchAllProducts({ page: 1, itemsPerPage: 8 }, this.searchQuery);
        }
        this.showResults = true;
        $(".search-input").css({
          "border-radius": "25px 25px 0 0",
          "border-bottom": "none",
        });
      },
      hideWithDelay(event) {
        const searchContainer = this.SearchInput;
        const resultsContainer = this.$refs.resultsContainer;

        if (
          searchContainer &&
          !searchContainer.contains(event.target) &&
          resultsContainer &&
          !resultsContainer.contains(event.target)
        ) {
          setTimeout(() => {
            this.showResults = false;
            $(".search-input").css({
              "border-radius": "25px",
              "border-bottom": "1px solid #AEB1BA",
            });
          }, 200);
        }
      },
      loadMore() {
        if (
          this.productsStore.loadingFilter ||
          this.productsStore.products.length >= this.productsStore.totalProducts
        ) {
          return;
        }
        this.productsStore.fetchAllProducts(
          {
            page: this.productsStore.currentPage + 1,
            itemsPerPage: 8,
            append: true,
          },
          this.searchQuery
        );
      },
      Increment(product) {
        const current = parseInt(this.qt[product.id], 10) || 0;
        this.qt[product.id] = Math.max(1, current + 1);
      },
      Decrement(product) {
        const current = parseInt(this.qt[product.id], 10) || 0;
        this.qt[product.id] = Math.max(1, current - 1);
      },

      onQtyInput(product, event) {
        const raw = event.target.value ?? "";
        const digits = String(raw).replace(/\D/g, "");
        this.qt[product.id] = digits;
      },

      onQtyBlur(product) {
        const val = parseInt(this.qt[product.id], 10);
        this.qt[product.id] = val && val > 0 ? val : 1;
      },

      onQtyKeydown(event) {
        const e = event;
        const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End", "Enter"];
        if (allowedKeys.includes(e.key)) return;
        if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x", "A", "C", "V", "X"].includes(e.key)) return;
        if (/^\d$/.test(e.key)) return;
        e.preventDefault();
      },

      async AddToCart(prod) {
        const qt_prod = parseInt(this.qt[prod.id], 10) || 0;
        if (!qt_prod || qt_prod <= 0) {
          this.toast.error("Veuillez sélectionner une quantité valide");
          return;
        }

        try {
          this.cartStore.loadingId = prod.id;

          // Apply promotion if delegate user selected a free unit percentage
          const freeUnitPercentage = this.selectedFreeUnits[prod.id];
          let promotionResponse = null;
          let freeQuantityToAdd = null;
          let isUg = null;
          let ugQuantity = null;

          if (this.isDelegue && freeUnitPercentage) {
            promotionResponse = await this.cartStore.applyPromotion(prod, qt_prod, freeUnitPercentage);
            console.log("Promotion response:", promotionResponse);

            // Check if promotion was successful and has calculated free quantity
            if (promotionResponse && promotionResponse.calculated_quantite_gagnee) {
              if (freeUnitPercentage !== 4) {
                freeQuantityToAdd = promotionResponse.calculated_quantite_gagnee;
                isUg = true;
              } else {
                isUg = true;
                ugQuantity = promotionResponse.calculated_quantite_gagnee;
              }
            }
          }

          console.log("Adding to cart with free quantity:", freeQuantityToAdd, "isUg:", isUg, ugQuantity);
          await this.cartStore.addToCart(prod.code, qt_prod, freeQuantityToAdd, isUg, ugQuantity);

          if (this.$route.path === "/dashboard") {
            this.ShowSuccessMsg = true;
            setTimeout(() => {
              this.ShowSuccessMsg = false;
            }, 2000);
          } else {
            this.toast.success("Produit ajouté au panier avec succès");
            this.showResults = false;
            $(".search-input").css({
              "border-radius": "25px",
              "border-bottom": "1px solid #AEB1BA",
            });
          }

          // Reset the free unit selection after adding to cart
          this.selectedFreeUnits[prod.id] = null;
          this.qt[prod.id] = 1;
        } catch (error) {
          this.toast.error("Erreur lors de l'ajout au panier");
          console.error("AddToCart error:", error);
        } finally {
          this.cartStore.loadingId = null;
        }
      },

      GoToCart() {
        this.$router.push({ name: "my-cart" });
      },

      formatPrice(value) {
        if (value == null || isNaN(value)) return "0,00";
        const num = Number(value) / 100;
        return num.toFixed(2).replace(".", ",");
      },
    },
  };
</script>

<style scoped>
  .go_payment {
    margin-left: 4px;
  }

  .message-added {
    position: absolute;
    right: 0%;
    top: -45%;
  }

  .d-cart {
    position: static;
    margin-left: 10px;
    /* Default order for desktop */
    order: 2;
  }

  .product-search {
    justify-content: center;

    > div {
      justify-content: center;
      align-items: center;
    }
  }

  .form-search {
    position: relative;
    flex-grow: 1;
  }

  .search-input {
    width: 100%;
    height: 50px;
    font-size: 13px;
    background: #ffffff 0% 0% no-repeat padding-box;
    padding: 0 45px 0 15px;
    border: 1px solid #aeb1ba;
    border-radius: 25px;
    outline: none;
  }

  .results {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #aeb1ba;
    border-top: none;
    border-radius: 0 0 25px 25px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 999;
    padding-bottom: 20px;
  }

  .product-card {
    display: flex;
    justify-content: space-between;
  }

  .product-image {
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    padding: 5px;
    height: 140px;
    width: auto;

    img.img-product {
      height: 130px;
    }
  }

  .product-image img {
    max-width: 100%;
  }

  .product-info {
    position: relative;

    .gamme {
      font-size: 15px;
      font-weight: 300;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }

    .title {
      font-size: 15px;
      font-weight: bold;
      font-style: normal;
      text-align: left;
      color: #1e347d;
    }
  }

  .result-item img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 5px;
  }

  .btn-minus,
  .btn-plus {
    width: 25px;
    height: 35px;
    color: #fff;
    font-size: 24px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
  }

  .btn-minus {
    background-color: #ec621a;
    opacity: 0.5;
  }

  .btn-plus {
    background-color: #ec621a;
  }

  .input-wrapper input {
    border-radius: 0;
  }

  .input-wrapper .btn-minus {
    border-radius: 30px 0 0 30px;
    font-size: 22px;
  }

  .input-wrapper .btn-plus {
    border-radius: 0 30px 30px 0;
    font-size: 22px;
  }

  .price {
    font-weight: bold;
    font-size: 20px;
    color: #000;
  }

  .currency {
    position: relative;
    bottom: 0;
    right: 0px;
    font-size: 13px;
    color: #000;
  }

  .add-cart {
    position: relative;
    left: -5%;
    display: flex;
    align-items: center;
  }

  .add-icon {
    position: relative;
    top: 25%;
    cursor: pointer;
  }

  .cart-wrapper {
    background-color: #ec621a;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .cart-container .cart-icon {
    width: 100%;
    height: 100%;
  }

  .cart-container .badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #1f327d;
    color: white;
    width: 20px;
    line-height: 20px;
    height: 20px;
    padding: 0;
    border-radius: 50%;
    font-size: 12px;
    font-weight: bold;
  }

  .check-payment {
    font-weight: bold;
    color: #1e347d;
    text-decoration: underline;
    cursor: pointer;
    text-align: left;
  }

  .success-add-product {
    color: #1e347d;
    font-size: 14px;
    position: relative;
    background: #c9cfde 0% 0% no-repeat padding-box;
    border-radius: 76px;
    padding: 5px 10px 0px 10px;
    left: 35px;
  }

  /* Delegate product styling */
  .delegate-product {
    border-left: 4px solid #ec621a;
    background-color: #fff8f5;
  }

  .delegate-badge {
    background-color: #ec621a;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: bold;
    margin-left: 10px;
  }

  .preorder-badge {
    display: inline-block;
    background-color: #1e347d;
    color: #fff;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  /* Free Unit Section Styles */
  .free-unit-section {
    margin-top: 10px;
    padding: 8px;
    background-color: #f8f9fa;
    border-radius: 5px;
    border: 1px solid #e9ecef;
  }

  .free-unit-label {
    display: block;
    font-size: 12px;
    font-weight: bold;
    color: #1e347d;
    margin-bottom: 5px;
  }

  .free-unit-checkboxes {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .checkbox-item {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-size: 11px;
    color: #495057;
  }

  .checkbox-item input[type="checkbox"] {
    margin: 0;
    cursor: pointer;
  }

  .checkbox-item span {
    white-space: nowrap;
  }

  .dot-spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    position: relative;
    left: -5%;
  }

  .dot-spinner {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: transparent;
    color: #ec621a;
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: 0.5s;
  }

  .dot-spinner::before,
  .dot-spinner::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }

  .dot-spinner::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ec621a;
    color: #ec621a;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  .dot-spinner::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ec621a;
    color: #ec621a;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: #ec621a;
    }
    50%,
    100% {
      background-color: rgba(236, 98, 26, 0.2);
    }
  }

  /* Responsive styles */
  @media (max-width: 1200px) {
    .row.product-search {
      flex-direction: column;
      align-items: stretch;
    }
    .col-lg-8 {
      width: 100%;
      max-width: 100%;
    }
    .d-cart {
      margin-left: 0;
      margin-top: 10px;
    }
  }
  @media (min-width: 480px) and (max-width: 767px) {
    .product-search .form-search i {
      right: 30px;
    }
  }
  @media (max-width: 768px) {
    .actions-cart {
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .row.product-search {
      flex-direction: column;
      align-items: stretch;
      padding: 0 10px;
    }
    .col-lg-8 {
      flex-direction: column;
      width: 100%;
      max-width: 100%;
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .d-cart {
      order: 0;
      margin-bottom: 10px;
    }
    .form-search {
      order: 1;
      width: 100%;
      margin: 0;
    }
    .search-input {
      height: 45px;
      font-size: 12px;
      padding: 0 35px 0 10px;
      width: 96%;
    }
    .results {
      top: 45px;
      left: 0;
      right: 0;
      width: 90vw;
      min-width: 100%;
      max-width: 100vw;
      box-sizing: border-box;
      padding-bottom: 10px;
      font-size: 14px;
      max-height: 50vh;
      overflow-y: auto;
      border-radius: 0 0 18px 18px;
      z-index: 9999;
    }
    .results-inner {
      padding: 8px 4px;
    }
    .result-item {
      padding: 8px 4px;
      margin-bottom: 4px;
    }
    .product-card {
      flex-direction: row;
      align-items: stretch;
      gap: 10px;
    }
    .left-product-card,
    .right-product-card {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
    .left-product-card {
      gap: 0px;
    }
    .product-image {
      height: 80px;
      padding: 2px;
    }
    .product-image img.img-product {
      height: 70px;
    }
    .result-item img {
      width: 30px;
      height: 30px;
    }
    .price {
      font-size: 16px;
    }
    .add-cart {
      left: 0;
    }
    .cart-wrapper {
      width: 40px;
      height: 40px;
    }
    .cart-container .badge {
      width: 16px;
      height: 16px;
      font-size: 10px;
      line-height: 16px;
    }
    .message-added {
      right: 0;
      top: -60px;
      font-size: 12px;
    }
    .success-add-product {
      left: 0;
      font-size: 12px;
      padding: 3px 6px 0px 6px;
    }
    .go_payment {
      margin-left: 5px;
      margin-top: 8px;
    }

    /* Responsive styles for checkboxes */
    .free-unit-section {
      padding: 6px;
    }

    .free-unit-checkboxes {
      gap: 6px;
    }

    .checkbox-item {
      font-size: 10px;
    }
  }

  @media (max-width: 480px) {
    .search-input {
      height: 36px;
      width: 100%;
      font-size: 10px;
      padding: 0 31px 0 9px;
    }

    .results {
      top: 38px;
      left: 0;
      right: 0;
      width: 85vw;
      min-width: 100%;
      max-width: 100vw;
      box-sizing: border-box;
      font-size: 12px;
      max-height: 45vh;
      overflow-y: auto;
      border-radius: 0 0 12px 12px;
      z-index: 9999;
    }
    .results-inner {
      padding: 6px 2px;
    }
    .result-item {
      padding: 6px 2px;
      margin-bottom: 2px;
    }
    .product-card {
      gap: 0px;
      flex-direction: row;
    }
    .product-info {
      margin: 0px;
    }
    .product-image {
      height: 50px;
      padding: 1px;
    }
    .product-image img.img-product {
      height: 45px;
    }
    .result-item img {
      width: 22px;
      height: 22px;
    }
    .price {
      font-size: 13px;
    }
    .cart-wrapper {
      width: 32px;
      height: 32px;
    }
    .cart-container .badge {
      width: 12px;
      height: 12px;
      font-size: 8px;
      line-height: 12px;
    }
    .message-added {
      top: -40px;
      font-size: 10px;
    }
    .success-add-product {
      font-size: 10px;
      padding: 2px 4px 0px 4px;
    }

    .free-unit-section {
      padding: 4px;
    }

    .free-unit-checkboxes {
      gap: 4px;
    }

    .checkbox-item {
      font-size: 9px;
    }
  }
  .btn-load-more {
    font-size: 11px;
    padding: 5px 10px;
  }

  /* Center cart icon on mobile screens */
  @media (max-width: 768px) {
    .d-cart {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px auto;
      width: 100%;
      text-align: center;
    }

    .d-cart .d-flex {
      justify-content: center;
    }
  }

  @media (max-width: 480px) {
    .d-cart {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 16px auto;
      width: 100%;
      text-align: center;
    }

    .d-cart .d-flex {
      justify-content: center;
    }
  }
</style>
